import React from "react";
import PricingCard from "./components/shared/PricingCard";
import RateItem from "./components/shared/RateItem";
import { RegularCardIcons, AmexCardIcon } from "./constants/icons";
import useSalesFormStore from "../../../../../../../../stores/sales-form";
import getPricingDataById from "./utils/get-pricing-data-by-id";
import formatPercentage from "./utils/format-percentage";
import formatCurrency from "./utils/format-currency";
import styles from "./style.module.scss";

const ICPlus = () => {
  const applicationData = useSalesFormStore((state) => state.applicationData);
  return (
    <div className={styles.icPlus}>
      <div className={styles.rateCards}>
        <PricingCard title="Rate Fees" icons={<RegularCardIcons />}>
          <div className={styles.ratesList}>
            <RateItem
              label="IC+ Rate"
              value={formatPercentage(
                getPricingDataById(2, applicationData?.prices)?.percent,
              )}
            />
            <RateItem
              label="Txn Rate"
              value={formatCurrency(
                getPricingDataById(2, applicationData?.prices)?.dollars,
              )}
            />
          </div>
        </PricingCard>

        <PricingCard title="Rate Fees AMEX" icons={<AmexCardIcon />}>
          <div className={styles.ratesList}>
            <RateItem
              label="IC+ Rate"
              value={formatPercentage(
                getPricingDataById(35, applicationData?.prices)?.percent,
              )}
            />
            <RateItem
              label="Txn Rate"
              value={formatCurrency(
                getPricingDataById(35, applicationData?.prices)?.dollars,
              )}
            />
          </div>
        </PricingCard>
      </div>
    </div>
  );
};

export default ICPlus;
